import React from "react";
import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import EditProfileComponent from "../components/auth/profile/EditProfileComponent";

const EditProfilePage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Edit Profile"
        routes={[{ title: "Home", path: "/" }]}
      />
      <EditProfileComponent />
    </>
  );
};
export default EditProfilePage;
